export const sectionToRoute = {
  'home-section': '/',
  'features-section': '/features',
  'pricing-section': '/pricing',
  'contact-section': '/contact',
};

export const sectionIds = Object.keys(sectionToRoute);

export const navLinks = [
  { to: '/', label: 'Home', section: 'home-section' },
  { to: '/features', label: 'Features', section: 'features-section' },
  { to: '/pricing', label: 'Pricing', section: 'pricing-section' },
  { to: '/contact', label: 'Contact', section: 'contact-section' },
]; 